import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

// Component Imports
import PageLayout from "../../components/PageLayout";
import { SectionHeading } from "../../components/SectionHeading";

const HeroSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-4 my-6 md:my-10">
      <div className="flex flex-col justify-center md:col-span-3 text-center md:text-left order-2 md:order-1 mt-4 md:mt-0">
        <SectionHeading>{t('DriverHero1')}</SectionHeading>
        <br/>
        <ol className="list-decimal list-inside text-sm md:text-base mx-auto md:mx-0 text-left max-w-xs md:max-w-none">
          <li>{t('DriverHero2')}</li>
          <li>{t('DriverHero3')}</li>
          <li>{t('DriverHero4')}</li>
        </ol>
      </div>
      <div className="md:col-span-2 flex justify-center order-1 md:order-2 mb-2 md:mb-0">
        <img
          src="../../../image/holding_hands.png"
          alt="Join us"
          className="w-[50%] md:w-auto"
        />
      </div>
    </div>
  );
};

const TutorialSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-4 my-6 md:my-10">
      <div className="flex flex-col justify-center col-span-1 md:col-span-2 text-center">
        <SectionHeading>{t('DriverTutorial1')}</SectionHeading>
      </div>

      <div className="grid grid-cols-2 gap-2 md:gap-4 my-4 order-1 md:order-1">
        <img className="max-w-[90%] mx-auto" src="../../../image/driver_setup_1.png" alt="Step 1" />
        <img className="max-w-[90%] mx-auto" src="../../../image/driver_setup_2.png" alt="Step 2" />
        <img className="max-w-[90%] mx-auto" src="../../../image/driver_setup_3.png" alt="Step 3" />
        <img className="max-w-[90%] mx-auto" src="../../../image/driver_setup_4.png" alt="Step 4" />
      </div>

      <div className="grid grid-rows-1 md:grid-rows-2 gap-6 md:gap-2 order-2 md:order-2">
        <div className="flex flex-col justify-center text-center md:text-left">
          <p className="text-sm md:text-base mb-2">{t('DriverTutorial1Note1')}</p>
          <p className="text-sm md:text-base mb-2">{t('DriverTutorial1Note2')}</p>
          <p className="text-sm md:text-base mb-2">{t('DriverTutorial1Note3')}</p>
          <p className="text-sm md:text-base">{t('DriverTutorial1Note4')}</p>
        </div>
        <div className="flex flex-col justify-center text-center md:text-left mt-6 md:mt-0">
          <SectionHeading>{t('DriverTutorial2')}</SectionHeading>
          <br/>
          <ul className="list-disc list-inside text-sm md:text-base mx-auto md:mx-0 text-left max-w-xs md:max-w-none">
            <li>{t('DriverTutorial2Note1')}</li>
            <li>{t('DriverTutorial2Note2')}</li>
            <li>{t('DriverTutorial2Note3')}</li>
            <li>{t('DriverTutorial2Note4')}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const CarTypeSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 my-6 md:my-10">
      <div className="flex flex-col items-center md:items-start">
        <SectionHeading size="md">{t('DriverEconomyCar')}</SectionHeading>
        <img
          src="../../../image/economy_car.png"
          alt="Economy Car"
          className="mt-4 w-[90%] md:w-auto"
        />
      </div>
      <div className="flex flex-col items-center md:items-start">
        <SectionHeading size="md">{t('DriverFastCar')}</SectionHeading>
        <img
          src="../../../image/fast_car.png"
          alt="Fast Car"
          className="mt-4 w-[90%] md:w-auto"
        />
      </div>
      <div className="flex flex-col items-center md:items-start sm:col-span-2 lg:col-span-1 sm:mx-auto">
        <SectionHeading size="md">{t('Driver7SeaterCar')}</SectionHeading>
        <img
          src="../../../image/7_seater_car.png"
          alt="7 Seater Car"
          className="mt-4 w-[90%] md:w-auto"
        />
      </div>
    </div>
  );
};

const DriverPage: React.FC = () => {
  return (
    <PageLayout>
      <div className="flex justify-center items-center w-full px-4 sm:px-0 pt-20">
        <main className="flex flex-col items-center w-full sm:w-[90%] md:w-[85%] lg:w-[80%]">
          <HeroSection />
          <TutorialSection />
          <CarTypeSection />
        </main>
      </div>
    </PageLayout>
  );
};

export default DriverPage;